/**
 * Script for the Front Page
 *
 * @author Space-Time Inc.
 * @version 2024-09-30
 */

document.addEventListener('DOMContentLoaded', () => {
	const KEY   = 'splash';
	const LIMIT = (1000 * 60 * 30);  // 30 min.

	initSplash();

	function initSplash() {
		if (!fromInside() && !location.hash && LIMIT < getElapsedTime()) {
			window.scrollTo(0, 0);
			setTimeout(run, 0);
			setCurrentTime();
		} else {
			clear();
		}
		setTimeout(() => {
			document.body.style.opacity = 1;
		}, 200);
	}

	function getElapsedTime() {
		const time = localStorage.getItem(KEY);
		if (parseInt(time, 10) === -1) {
			setCurrentTime();
			return 0;
		}
		return time ? Date.now() - time : Number.MAX_VALUE;
	}

	function setCurrentTime() {
		localStorage.setItem(KEY, Date.now());
	}

	function fromInside() {
		const host = location.hostname;
		const ref  = document.referrer;
		return -1 !== ref.indexOf(host);
	}


	// -------------------------------------------------------------------------


	function run() {
		const ptv = document.querySelector('.part-top-visual');
		const svg = document.querySelector('.part-top-visual svg');

		const kv = document.querySelector('.part-top-visual .tv-key');
		kv.addEventListener('load', () => {
			document.body.style.opacity = 1;
			ptv.classList.add('active');
			svg.classList.add('active');
		});
		kv.src = kv.dataset['src'];
	}

	function clear() {
		const ptv = document.querySelector('.part-top-visual');

		const kv = document.querySelector('.part-top-visual .tv-key');
		kv.addEventListener('load', () => {
			document.body.style.opacity = 1;
			ptv.classList.add('no-splash');
		});
		kv.src = kv.dataset['src'];
	}
});
